module.exports = __webpack_public_path__ + "static/media/mansong.d05eebeb.png";